module.exports = __webpack_public_path__ + "static/media/homePlate2Icon2.7033307f.png";